import React from 'react';
import styled from 'styled-components';
import { CustomerInfoPopoverUI, IconInfo, useCustomerInfoPopover } from '../CustomerName';
import { maskPhone } from 'utils/formatPhone';
import Popover from 'antd/lib/popover';
import { useRequestAdminPWCallbackRef } from 'widgets/RequestAdminLocalPW/Callback';
import { customerEditorRef } from '../../../CustomerEditor';
import { useAppDispatch } from 'store/hooks';
import appointmentActions from 'features/appointment/services/actions';

type Props = {
  customerName?: string;
  customerPhone?: string;
  customerId?: string;
};

const PopoverCustomerInfo = ({ customerName, customerPhone, customerId }: Props) => {
  const text = `${customerName} - ${customerPhone ? maskPhone(customerPhone) : 'Unknown'}`;
  const dispatch = useAppDispatch();
  const pinCodeRef = useRequestAdminPWCallbackRef();
  const {
    customerInfo,
    customerDetailLoading,
    viewCustomer,
    open,
    setOpen,
    handleCheckPassBeforeView,
    dataPin,
    callback,
  } = useCustomerInfoPopover(customerId || '');
  const onToggleCustomerBox = () => {
    return pinCodeRef.current?.open((pin, data) => {
      callback(pin, data);
    }, true);
  };
  const onOpenChange = (val: boolean) => handleCheckPassBeforeView?.(val);

  const onEdit = () => {
    customerEditorRef.current?.openWithId(customerInfo?.customerId || '', {
      addon: customerInfo,
      onSuccess: (data) => {
        if (data) {
          dispatch(appointmentActions.syncCustomerInfo(data));
        }
      },
    });
    setOpen?.(false);
  };

  return (
    <Container>
      <Wrapper>
        <Popover
          placement='rightTop'
          title={null}
          content={
            <CustomerInfoPopoverUI
              loading={customerDetailLoading}
              customerInfo={customerInfo}
              onOpenChange={onOpenChange}
              onEdit={onEdit}
              dataPin={dataPin}
            />
          }
          open={open}
          trigger={'click'}
          onOpenChange={onOpenChange}
          overlayInnerStyle={{ padding: 16, borderRadius: 8, background: '#E4F4F6' }}
        >
          <button type='button' onClick={onToggleCustomerBox}>
            <IconInfo />
          </button>
        </Popover>
        <EllipsisContainer>{text}</EllipsisContainer>
      </Wrapper>
    </Container>
  );
};

export default PopoverCustomerInfo;

const Container = styled.div`
  flex: 1;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const EllipsisContainer = styled.div`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #1d2129;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;
